// extracted by mini-css-extract-plugin
export default {"headerGreetingSection":"HomepageHeaderGreeting_headerGreetingSection__dvHjO"};